// extracted by mini-css-extract-plugin
module.exports = {"m--number-text":"NumberText_m--number-text__rlcQA","m--bubble":"NumberText_m--bubble__nUh2g","m--percent-sign":"NumberText_m--percent-sign__HUVdz"};